module.exports = __webpack_public_path__ + "static/media/PGSERIESIMAGE.abc71032.png";